// extracted by mini-css-extract-plugin
export default {"ScoreList":"List_ScoreList__NuoO4","ScoreGridColumn":"List_ScoreGridColumn__c80eP","HeaderWrapper":"List_HeaderWrapper__6aKwA","HeaderButtons":"List_HeaderButtons__FBmGe"};